import { featureEnabled } from './featureFlagBrowserClient';

const getInternalShowingDetailsUrl = (appointmentId: string) => `/my_business/${
    featureEnabled('showingDetailsRevampFeaturePhase', 1)
      ? 'showing'
      : 'appointment'
  }/${appointmentId}`;

export default getInternalShowingDetailsUrl;
